export default {
  list: [
    {
      value: 'PENDING',
      title: 'در انتظار'
    },
    {
      value: 'TRANSFERRING',
      title: 'انتقال به بانک'
    },
    {
      value: 'PAID',
      title: 'پرداخت شده'
    },
    {
      value: 'ERROR',
      title: 'خطا در پرداخت'
    },
    {
      value: 'CANCEL_BY_CUSTOMER',
      title: 'انصراف از پرداخت'
    },
    {
      value: 'TIMEOUT',
      title: 'اتمام زمان مجاز پرداخت'
    }
  ],
  values: {
    PENDING: 'PENDING',
    PAID: 'PAID',
    BANNED: 'ERROR',
    TRANSFERRING: 'TRANSFERRING',
    CANCEL_BY_CUSTOMER: 'CANCEL_BY_CUSTOMER',
    TIMEOUT: 'TIMEOUT'
  }
};
